import { PaginationUpdatePayload } from 'features/layout/features/pagination/types';
import { updatePagination } from 'features/layout/pagination/updatePagination';
import { call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { RTCClient } from 'utils/webrtc';

export function* onPaginationSaga(action: PayloadAction<PaginationUpdatePayload>) {
  yield call(updatePagination, action.payload);

  // The page change just paused and resumed videos; the quality tier keys on how many are left.
  yield call(RTCClient.receivingFeed.updateSimulcastConfig);
}
